import {
  astro,
  react,
  qwik,
  nativescript,
  next,
  nuxt,
  vue,
  slidev,
  remotion,
  remix,
  svelte,
  typescript,
  vite,
} from "../assets/image";

import { angular } from "../assets/image";
import { IMAGE } from "../type";

export const FlowIcons: IMAGE[] = [
  {
    image: angular,
    alt: "agular",
  },
  {
    image: astro,
    alt: "astro",
  },
  {
    image: nativescript,
    alt: "nativescript",
  },
  {
    image: next,
    alt: "next",
  },
  {
    image: nuxt,
    alt: "nuxt",
  },
  {
    image: qwik,
    srcSet: "",
    alt: "qwik",
  },
  {
    image: react,
    alt: "react",
  },
  {
    image: remix,
    alt: "remix",
  },
  {
    image: remotion,
    alt: "remotion",
  },
  {
    image: slidev,
    alt: "slidev",
  },
  {
    image: svelte,
    srcSet: "",
    alt: "svelte",
  },
  {
    image: typescript,
    alt: "typescript",
  },
  {
    image: vite,
    alt: "vite",
  },
  {
    image: vue,
    alt: "vue",
  },
];
